<template>
  <b-card class="jlr-brand-card cx-card" 
          :class="{'jaguar-style': brand == 'Jaguar', 
                  'landrover-style': brand == 'Land Rover'}">
 
    <img  class="mx-auto img-fluid jlr-brand-card-logo" :src="`/static/img/${logoName}`" />

    <b-card-text class="msm-title" style="letter-spacing: -0.025em; font-size: 1.2rem;">
      {{ actualTitle || title }}
    </b-card-text>

    <b-card-text v-if="!loadingData">
      <slot />
    </b-card-text>

  </b-card>
</template>

<script>
import EventBus from "@/services/EventBus";

export default {
  components: {
  },

  props: {
    brand:                        { type: String, default: 'Jaguar' },
    theme:                        { type: String, default: () => 'light' },
    title:                        { type: String, default: '' }
  },

  data() {
    return {
      loadingData: false,
      showPopup: false,
      titleAppendix: '55'
    };
  },

  mounted() {
    if (this.title.includes('NPS - NPS')) {
      if(this.$el.children[0].innerText.includes('\n2023\n')) {
         this.titleAppendix = '55';
      }
      EventBus.$on('nps-margin-header', this.handleNpsMarginHeader);
    }
  },
  
  beforeDestroy() {
    if (this.title.includes('NPS - NPS')) {
      EventBus.$off('nps-margin-header', this.handleNpsMarginHeader);
    }
  },

  methods: {
    handleNpsMarginHeader(data) {
      this.titleAppendix = data;
    }
  },

  computed: {
    actualTitle() {
      if (this.title.includes('NPS - NPS') && this.titleAppendix && this.titleAppendix.length > 0) {
        return this.title + ' +' + this.titleAppendix;
      }
      return this.title;
    },
    logoName() {
      let themeFlavour = this.theme === 'light' ? '' : '-dark';
      return this.brand == "Jaguar" 
        ? `jaguar-logo-23${themeFlavour}.png`
        : `landrover-logo-23${themeFlavour}.png`;
    }
  }
};
</script>
